import { Divider, Grid2, SvgIcon, Typography } from "@mui/material";
import { IntegrationDialogProps } from "@custom-types/integrations-types";
import { DEFAULT_INPUT_FONT_SIZE } from "@styles/common-styles";
import CheckRectangular from "@assets/icons/new/check_rectangular_l18.svg?react";
import TabsIntegrations from "@assets/icons/new/tabs_integration.svg?react";
import { INTEGRATION_INFO } from "@src/constants/integrations-constants";
import { Dialog } from "@flat-ui";

/** Shows dialog for successfully connecting to an integration */
export function IntegrationsSuccessfulDialog({
  dialogConfirmCallback,
  integrationId,
}: IntegrationDialogProps): JSX.Element {
  return (
    <Dialog
      open={true}
      onConfirm={dialogConfirmCallback}
      confirmText="Got it"
      title=""
    >
      <Grid2
        maxWidth="100%"
        alignItems="center"
        container
        flexDirection="column"
        sx={{
          paddingX: "28px",
        }}
      >
        <Typography
          sx={{
            fontSize: "32px",
          }}
        >
          Integration connected
        </Typography>
        <Typography
          sx={{
            fontSize: DEFAULT_INPUT_FONT_SIZE,
            marginBottom: "40px",
          }}
        >
          {`Enable ${INTEGRATION_INFO[integrationId].displayName} in your project whenever you want`}
        </Typography>
        <SvgIcon
          inheritViewBox={true}
          component={CheckRectangular}
          sx={{
            width: "95px",
            height: "95px",
          }}
        />

        <Divider
          sx={{
            marginY: "40px",
            width: "100%",
          }}
        />

        <Typography
          sx={{
            fontSize: DEFAULT_INPUT_FONT_SIZE,
            marginTop: "0px",
            marginBottom: "40px",
            textAlign: "center",
          }}
        >
          {`To use ${INTEGRATION_INFO[integrationId].displayName}, you need to enable it in a
            Sphere XG project. To do this, go to the "Integrations" tab on the project details page.`}
        </Typography>
        <SvgIcon
          inheritViewBox={true}
          component={TabsIntegrations}
          sx={{ width: "450px", height: "72px" }}
        />
      </Grid2>
    </Dialog>
  );
}
